<!-- src/apps/workspace/account/settings/CautionZone.vue -->

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import AccountCard from '@/apps/workspace/components/account/AccountCard.vue';
  import AccountDeleteButtonWithModalForm from '@/apps/workspace/components/account/AccountDeleteButtonWithModalForm.vue';
  import SettingsLayout from '@/apps/workspace/layouts/SettingsLayout.vue';
  import { useBootstrapStore } from '@/shared/stores/bootstrapStore';
  import { storeToRefs } from 'pinia';

  const { t } = useI18n();
  const bootstrapStore = useBootstrapStore();
  const { cust } = storeToRefs(bootstrapStore);
</script>

<template>
  <SettingsLayout>
    <!-- no-symbol: Reserved exclusively for destructive/irreversible actions -->
    <AccountCard
      danger
      :icon="{ collection: 'heroicons', name: 'no-symbol' }"
      :title="t('web.COMMON.caution_zone')">
      <div class="p-[22px]">
        <!--
          A second, deeper red panel INSIDE the card. The mock nests them so
          the closure form reads as a walled-off area rather than as the card's
          ordinary body — the visual equivalent of the confirmation step.
        -->
        <div
          class="border border-red-500/20 bg-red-500/[0.05] p-[22px]
            dark:border-red-500/25 dark:bg-red-500/[0.07]">
          <h3 class="mb-0 font-brand text-xl font-normal text-red-700 dark:text-red-400">
            {{ t('web.auth.close_account.title') }}
          </h3>
          <p class="mt-1 text-[13px] text-red-600 dark:text-red-400/80">
            {{ t('web.settings.delete_account.permanently_delete_your_account') }}
          </p>

          <!-- Authentication check: cust is null for anonymous users (via AuthenticationSerializer),
               cust.objid confirms a fully hydrated customer object -->
          <div class="mt-[18px]">
            <AccountDeleteButtonWithModalForm
              v-if="cust?.objid"
              :cust="cust" />
          </div>
        </div>
      </div>
    </AccountCard>
  </SettingsLayout>
</template>
